<div class="dx-user-bar">
  <div class="dx-user-info" *ngIf="session; else loading">
    <div class="dx-user-info__line">{{session.name}}</div>
    <div class="dx-user-info__line">{{session.position}}</div>
  </div>
  <ng-template #loading>
    <div>Loading ...</div>
  </ng-template>
</div>
